// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { ModalTokens } from './type';

const modalTokens: ModalTokens = {
  modalMaskBackground: 'Mask-fill-1',
  modalMaskLightBackground: 'Neutral-mask-2',
  modalPanelPaddingY: 'Spacing-24',
  modalPanelPaddingX: 'Spacing-24',
  modalPanelBackground: 'Neutral-fill-1',
  modalPanelShadow: 'Shadow-3',
  modalPanelBorder: 'Neutral-border-1',
  modalPanelGap: 'Spacing-16',
  modalPanelRadius: 'Radius-default',
  modalPanelFontSize: 'Font-14',
  modalHeaderIconMarginEnd: 'Spacing-8',
  modalHeaderIconMarginTop: 'Spacing-3',
  modalHeaderIconSize: 'Size-9',
  modalHeaderCloseMarginXStart: 'Spacing-16',
  modalHeaderCloseSize: 'Size-8',
  modalHeaderCloseTop: 'Size-2',
  modalHeaderCloseColor: 'Neutral-text-4',
  modalHeaderCloseBackgroundColor: 'Neutral-fill-2',
  modalHeaderFontSize: 'Font-16',
  modalHeaderFontWeight: 'Weight-medium',
  modalHeaderFontColor: 'Neutral-text-5',
  modalBodyFontColor: 'Neutral-text-5',
  modalBodyFontWeight: 'Weight-regular',
  modalBodyFontSize: 'Font-14',
  modalDrawerTitlePaddingY: 'Spacing-12',
  modalDrawerTitlePaddingX: 'Spacing-16',
  modalDrawerTitleBackgroundColor: 'Neutral-fill-2',
  modalDrawerHeaderBorderColor: 'Neutral-border-1',
  modalDrawerHeaderBorderWidth: 'Border-0',
  modalDrawerBodyPaddingY: 'Spacing-16',
  modalDrawerBodyPaddingX: 'Spacing-16',
  modalDrawerFooterBorderColor: 'Neutral-border-1',
  modalDrawerFooterBorderWidth: 'Border-0',
  modalDrawerFooterPaddingY: 'Spacing-16',
  modalDrawerFooterPaddingX: 'Spacing-16',
  modalDrawerCloseBackgroundColor: 'Neutral-fill-3',
  modalFontSize: 'Font-14',
};

export default modalTokens;
